module.exports = __webpack_public_path__ + "static/media/25a.57b95280.jpg";